import { Component } from '@angular/core';

@Component({
  templateUrl: './account-settings.page.html',
})
/**
 * Account Settings Page!
 */
export class AccountSettingsPage {}
